var TypeValidationError;

TypeValidationError = Immutable.Record({
  message: 'Type validation failed',
  validation: 'Generic',
  _meta: {}
}, 'TypeValidationError');

module.exports = TypeValidationError;
